import { ThumbsUp, ThumbsDown } from "lucide-react";
import { Button } from "@design-lab/shared/ui";

export type FeedbackThumbActionsProps = {
  onPositiveClick: () => void;
  onNegativeClick: () => void;
  showLabel?: boolean;
};

export function FeedbackThumbActions({
  onPositiveClick,
  onNegativeClick,
  showLabel = true
}: FeedbackThumbActionsProps) {
  return (
    <div className="flex w-full flex-col gap-3 lg:flex-row lg:items-center lg:gap-3">
      {showLabel && (
        <div className="text-nowrap text-sm text-gray-950 lg:mr-2 [@media(min-width:1024px)_and_(max-width:1050px)]:whitespace-normal">
          Happy with your image?
        </div>
      )}

      <div className="flex w-full gap-4 lg:ml-auto lg:w-auto">
        <Button
          className="flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-2 py-6 text-base font-medium text-black hover:bg-gray-50 lg:flex-none lg:gap-2 lg:px-3 lg:py-2.5"
          data-testid="artwork-feedback-yes"
          variant="secondary"
          onPress={onPositiveClick}
          aria-label="Yes, happy with image"
        >
          <span>Yes</span>
          <ThumbsUp className="size-8 text-green-500 lg:size-6" />
        </Button>
        <Button
          className="flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-2 py-6 text-base font-medium text-black hover:bg-gray-50 lg:flex-none lg:gap-2 lg:px-3 lg:py-2.5"
          data-testid="artwork-feedback-no"
          variant="secondary"
          onPress={onNegativeClick}
          aria-label="No, not happy with image"
        >
          <span>No</span>
          <ThumbsDown className="size-8 text-red-500 lg:size-6" />
        </Button>
      </div>
    </div>
  );
}
